import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  linkAddress: {
    color: theme.colorPalette.green_90
  },
  leftItem: {
    paddingRight: theme.spacing(5)
  },
  rightItem: {
    paddingLeft: theme.spacing(5)
  }
});

export default makeStyles(styles);
